import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IDeptCdState, IDutyCdState, IMmbrItemsState, IPostCdState, IUserStCdState, IUsr0103P1State, IEduState, IEduTpState, ICertState, ICertTpState } from '../../models/usr/usr0103p1_model';
  
const initialState: IUsr0103P1State = {
    mmbrItems: {
        empNo      : '',     // 사원번호
        userNm     : '',     // 사용자명
        deptCd     : '',     // 부서코드
        userTpCd   : '01',   // 사용자구분
        postCd     : '01',   // 직위
        dutyCd     : '01',   // 직책
        userStCd   : 'A',    // 사용자상태(활동)
        userId     : '',     // 사용자ID
        mobileNo   : '',     // 휴대폰
        userEmail  : '',     // 이메일
        userAddr   : '',     // 주소
        pswd       : '',     // 비밀번호
        joinDt     : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'),    //  입사일자
        leaveDtm   : '',     // 탈퇴일시
        oldPswd    : '',     // 기존비밀번호
        newPswd    : '',     // 새비밀번호
        chkPswd    : '',     // 비밀번호확인
        initPswd   : false,  // 비밀번호초기화
        deptHdrYn  : 'N',    // 부서장여부
        birdTpCd   : '01',   // 생일유형코드
        gndrTpCd   : '01',   // 성별유형코드
        milCmpltYn : '',     // 군필여부
        realEntDt  : '',     // 실입사일
        birdDt     : '',     // 생년월일
    },
    deptCdList : [],
    dutyCdList : [],
    postCdList : [],
    userStCdList : [],
    eduList : [],
    eduTpList : [],
    selectedEduRowKeys : [],
    certList : [],
    certTpList : [],
    selectedCertRowKeys : [],
}

export const usr0103p1_Slice = createSlice({
    name: 'usr0101m_Slice',
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {
                ...initialState,
                deptCdList : state.deptCdList,
                dutyCdList : state.dutyCdList,
                postCdList : state.postCdList,
                eduTpList  : state.eduTpList,
                certTpList : state.certTpList,
                userStCdList : state.userStCdList,
            });
        },
        setMmbrItems: (state, action:PayloadAction<IMmbrItemsState>) => {
            state.mmbrItems = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
        setDutyCdList: (state, action:PayloadAction<IDutyCdState[]>) => {
            state.dutyCdList = action.payload;
        },
        setPostCdList: (state, action:PayloadAction<IPostCdState[]>) => {
            state.postCdList = action.payload;
        },
        setUserStCdList: (state, action:PayloadAction<IUserStCdState[]>) => {
            state.userStCdList = action.payload;
        },
        setEduTpList: (state, action:PayloadAction<IEduTpState[]>) => {
            state.eduTpList = action.payload;
        },
        setEduList: (state, action:PayloadAction<IEduState[]>) => {
            state.eduList = action.payload;
        },
        setEduItem: (state, action:PayloadAction<IEduState>) => {
            const tmpArr:IEduState[] = state.eduList.map((item) => {
                return item.id === action.payload.id ? { ...item, ...action.payload } : item;
            });

            return {
                ...state,
                eduList : tmpArr
            }
        },
        removeEduItems: (state, action:PayloadAction<number[]>) => {
            const tmpArr:IEduState[] = state.eduList.filter((item) => {
                return !action.payload.includes(item.id);
            });

            return {
                ...state,
                eduList : tmpArr
            }
        },
        setSelectedEduRowKeys: (state, action:PayloadAction<number[]>) => {
            state.selectedEduRowKeys = action.payload;
        },
        setCertTpList: (state, action:PayloadAction<ICertTpState[]>) => {
            state.certTpList = action.payload;
        },
        setCertList: (state, action:PayloadAction<ICertState[]>) => {
            state.certList = action.payload;
        },
        setCertItem: (state, action:PayloadAction<ICertState>) => {
            const tmpArr:ICertState[] = state.certList.map((item) => {
                return item.id === action.payload.id ? { ...item, ...action.payload } : item;
            });

            return {
                ...state,
                certList : tmpArr
            }
        },
        removeCertItems: (state, action:PayloadAction<number[]>) => {
            const tmpArr:ICertState[] = state.certList.filter((item) => {
                return !action.payload.includes(item.id);
            });

            return {
                ...state,
                certList : tmpArr
            }
        },
        setSelectedCertRowKeys: (state, action:PayloadAction<number[]>) => {
            state.selectedCertRowKeys = action.payload;
        },
    },
});

export default usr0103p1_Slice.reducer;
export const Usr0103p1Action  = usr0103p1_Slice.actions;
export const Usr0103p1Reducer = usr0103p1_Slice.reducer;